import api from "@/services/api"

export type LogInAsCashierPayload = {
  cashierId: string | null
  pin: string | null
}

export const logInAsCashier = async (
  payload: LogInAsCashierPayload
): Promise<{ accessToken: string }> => {
  const { body } = await api.post<{ accessToken: string }>(
    "/auth/app/cashier-login/",
    { body: payload }
  )
  return body
}
